import { autoMount } from '../../../utils/autoMount';
import { RecruitmentShow } from '../../../components/pages/recruitmentShow';

autoMount({ RecruitmentShow });
